// CsvContext.js
import { createContext, useContext, useState, useEffect } from 'react';

const CsvContext = createContext();

export const LinkedinScrapperCsvContext = ({ children }) => {
  const [csvColumns, setCsvColumns] = useState([]);
  const [csvRows, setCsvRows] = useState([]);
  const [csvLoading, setCsvLoading] = useState(true); // 👈 loading state

  // Load from sessionStorage on mount
  useEffect(() => {
    const savedColumns = sessionStorage.getItem('csvColumns');
    const savedRows = sessionStorage.getItem('csvRows');

    if (savedColumns) setCsvColumns(JSON.parse(savedColumns));
    if (savedRows) setCsvRows(JSON.parse(savedRows));

    setCsvLoading(false); // 👈 mark as loaded
  }, []);

  // Save/overwrite sessionStorage whenever csvColumns changes
  useEffect(() => {
    if (!csvLoading) {
      sessionStorage.setItem('csvColumns', JSON.stringify(csvColumns));
    }
  }, [csvColumns, csvLoading]);

  // Save/overwrite sessionStorage whenever csvRows changes
  useEffect(() => {
    if (!csvLoading) {
      sessionStorage.setItem('csvRows', JSON.stringify(csvRows));
    }
  }, [csvRows, csvLoading]);

  return (
    <CsvContext.Provider value={{ csvColumns, csvRows, setCsvColumns, setCsvRows, csvLoading }}>
      {children}
    </CsvContext.Provider>
  );
};

export const useCsv = () => useContext(CsvContext);
